export default function fancyBox(){
    if(document.querySelector("[data-fancybox='gallery']")){
        Fancybox.bind("[data-fancybox='gallery']", {
            Thumbs: {
                type: "classic",
            },
        });

        Fancybox.bind("[data-fancybox='gallery-mobile']", {
            Thumbs: {
                type: "classic",
            },
        }); 
    } 
    if (document.querySelector(".depoiment__play")) {
        Fancybox.bind("[data-fancybox='depoiment']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
    
    Fancybox.bind("[data-fancybox='video-work']", {
        Thumbs: {
            type: "classic",
        },
    }); 

    Fancybox.bind("[data-fancybox='photo']", {
        Thumbs: {
            type: "classic",
        },
    });  

    Fancybox.bind("[data-fancybox='testimony']", {
        Thumbs: {
            type: "classic",
        },
    });


    Fancybox.bind("[data-fancybox='gallery-donate']", {
        Thumbs: {
            type: "classic",
        },
    });
}
